<div class="modal-header">
  <h2 class="h2 modal-title ">{{ 'Booking.label_confirmationLetter' | translate }}</h2>
  <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="_ngbActiveModal.dismiss()"></button>
</div>
<div class="modal-body">
  <p>
    <strong>{{ 'Booking.label_confirmation_letter_note_email' | translate }}</strong>
  </p>

  <div class="mb-3">
    <label class="form-label d-block">{{ 'Booking.label_send' | translate }}</label>
    <div class="row">
      <div class="col-6 d-flex gap-2 ">
        <input
          class="form-check-input"
          type="radio"
          name="versionType"
          id="versionTypeAgent"
          value="AGENCY"
          [(ngModel)]="versionType"
          (ngModelChange)="handleVersionTypeChange($event)"
        />
        <label class="form-check-label" for="versionTypeAgent">{{ 'Booking.label_send_to_agent' | translate }}</label>
      </div>
      <div class="col-6 d-flex gap-2">
        <input
          class="form-check-input"
          type="radio"
          name="versionType"
          id="versionTypeGuest"
          value="GUEST"
          [(ngModel)]="versionType"
          (ngModelChange)="handleVersionTypeChange($event)"
        />
        <label class="form-check-label" for="versionTypeGuest">{{ 'Booking.label_send_to_guest' | translate }}</label>
      </div>
    </div>

  </div>
  <div class="row">
    <div class="col-6">
      <div class="mb-3">
        <label for="contactValueAgent" class="form-label">{{ 'Booking.label_contact_agent' | translate }}</label>
        <input
          id="contactValueAgent"
          type="text"
          class="form-control"
          placeholder="Email"
          [(ngModel)]="contactValueAgent"
          [disabled]="versionType === 'GUEST'"
        />
      </div>
    </div>

    <div class="col-6">
      <div class="mb-3">
        <label for="contactValueGuest" class="form-label">{{ 'Booking.label_contact_customer' | translate }}</label>
        <input
          id="contactValueGuest"
          type="text"
          class="form-control"
          placeholder="Email"
          [(ngModel)]="contactValueGuest"
          [disabled]="versionType === 'AGENCY'"
        />
      </div>
    </div>
  </div>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-white me-auto" (click)="_ngbActiveModal.dismiss()">
    <i class="bi bi-chevron-left me-1"></i> {{ 'Reservation.btn_Cancel' | translate }}
  </button>
  <button
    type="button"
    class="btn btn-primary"
    (click)="sendConfirmationLetter()"
    [ngClass]="{ disabled: (versionType === 'AGENCY' && (!contactValueAgent || contactValueAgent === '')) || (versionType === 'GUEST' && (!contactValueGuest || contactValueGuest === '')) }"
  >
    {{ 'Reservation.btn_send_email' | translate }}
  </button>
</div>
